import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { getLocaleCurrencySymbol, getCurrencySymbol } from '@angular/common';

import { environment } from '@env/environment';

import { Logger } from '@core/utils';

import { LoaderComponent } from '@shared/components';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent],
  template: ` <router-outlet /> <app-loader />`,
})
export class AppComponent implements OnInit {
  cheatLocalSymbol = getLocaleCurrencySymbol('es-PE');
  cheatSymbol = getCurrencySymbol('es-PE', 'wide');

  async ngOnInit() {
    if (environment.production) {
      Logger.enableProductionMode();
    }

    this.loadScript();

  }

  loadScript() {
    const node = document.createElement('script');
    node.type = 'text/javascript';
    node.async = true;
    document.querySelectorAll('head')[0].append(node);
  }
}
